import APIClient from '@/shared/http/clients/api'

const resourceName = 'APRTemplateLog'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAPRTemplateLogById = (templateid, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAPRTemplateLogById/${templateid}`, data, config)

const AaprLogTemplateRepository = {
  GetAPRTemplateLogById
}

export default AaprLogTemplateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprLogTemplate.js